import { render, staticRenderFns } from "./TwoFactorAuthBlock.vue?vue&type=template&id=433ebf2c&scoped=true"
import script from "./TwoFactorAuthBlock.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthBlock.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthBlock.vue?vue&type=style&index=0&id=433ebf2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ebf2c",
  null
  
)

export default component.exports